module.exports = __webpack_public_path__ + "img/banner9.d925016.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner9.png
// module id = N0et
// module chunks = 2